import React, { useState, useRef } from 'react';
import { useForm } from 'react-hook-form';

import { Form, Row, Col, Button, Container, InputGroup } from 'react-bootstrap';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import { GrClose } from 'react-icons/gr';
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { RiLoader4Line } from 'react-icons/ri';
import http from "../../../services/Api";
import swal from 'sweetalert';

import './index.css'

function PasswordModal() {
  const body = document.getElementsByTagName('body')[0];
  const [loading, setLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordRepeatShown, setPasswordRepeatShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const togglePasswordRepeatVisiblity = () => {
    setPasswordRepeatShown(passwordRepeatShown ? false : true);
  };

  const { register, handleSubmit, errors, watch } = useForm();
  const password = useRef({});
  password.current = watch("password", "");

  const closeModal = () => {
    ModalManager.close();
    body.style.overflow = 'auto'
  }

  const handleSave = async passwords => {
    setLoading(true);

    const { password } = passwords;
    try {
      const response = await http.post('/api/me/change-password', { password });

      setLoading(false);

      ModalManager.close();
      body.style.overflow = 'auto'

      swal("Senha alterada com sucesso!", {
        title: "Sucesso!",
        icon: "success",
      })

      return response.data;

    } catch (e) {
      console.log(e);
      setLoading(false);

      ModalManager.close();
      body.style.overflow = 'auto'
      swal("Erro!", "Não foi possível alterar sua senha.", "error");
      return null;
    }
  }

  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999999,
      overflowX: 'hidden',
      overflowY: 'auto',
      perspective: 1300,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      position: 'relative',
      border: '1px solid rgba(0, 0, 0, .2)',
      width: 'inherit',
      background: '#fff',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
    }
  }

  return (
    <div className="PasswordModal">

      <Modal
        style={style}
        onRequestClose={() => { }}
        effect={Effect.Fall}>

        <Container fluid>

          <div className="header">
            <div className="title">
              Alterar senha
          </div>

            <div className="actions">
              <GrClose onClick={closeModal} />
            </div>
          </div>

          <div className="body">
            <Form method="POST" onSubmit={handleSubmit(handleSave)}>

              <Form.Group as={Row} name="password" controlId="password">
                <Form.Label column sm="2">
                  Senha
                </Form.Label>
                <Col sm="10">
                  <InputGroup>
                    <Form.Control
                      name="password"
                      placeholder="Digite sua Senha"
                      type={passwordShown ? "text" : "password"}
                      ref={register({
                        minLength: {
                          value: 8,
                          message: "A senha deve ter no mínimo 8 caracteres"
                        },
                        pattern: {
                          value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*/#?&])[A-Za-z\d@$!%*/#?&]{8,}$/i,
                          message: "A senha deve conter ao menos um caractere maiúsculo e um caractere especial"
                        }
                      })}
                      required
                    />
                    <InputGroup.Prepend>
                      <InputGroup.Text>
                        {
                          passwordShown
                            ? <FaEye onClick={togglePasswordVisiblity} />

                            : <FaEyeSlash onClick={togglePasswordVisiblity} />

                        }
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                  </InputGroup>
                  <span className="form-error">
                    {errors.password && <p>{errors.password.message}</p>}
                  </span>
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="confirmaPassword">
                <Form.Label column sm="2">
                  Confirmar Senha
                </Form.Label>
                <Col sm="10">
                  <InputGroup>
                    <Form.Control
                      name="password_repeat"
                      type={passwordRepeatShown ? "text" : "password"}
                      placeholder="Confirme sua Senha"
                      ref={register({
                        validate: value =>
                          value === password.current || "As senhas devem ser iguais"
                      })}
                      required
                    />
                    <InputGroup.Prepend>
                      <InputGroup.Text>
                        {
                          passwordRepeatShown
                            ? <FaEye onClick={togglePasswordRepeatVisiblity} />

                            : <FaEyeSlash onClick={togglePasswordRepeatVisiblity} />

                        }
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                  </InputGroup>
                  <span className="form-error">
                    {errors.password_repeat && <p>{errors.password_repeat.message}</p>}
                  </span>
                </Col>
              </Form.Group>
              <InputGroup>
                <Button variant="primary" type="submit">
                  {
                    loading ? (<RiLoader4Line className="spin" />) : 'Salvar'
                  }
                </Button>
              </InputGroup>
            </Form>
          </div>
        </Container>
      </Modal>
    </div>
  );
}

export default PasswordModal;